export default "__VITE_ASSET__7HoiVrRG__"